import _ from 'lodash';
import { Checkbox, TextField } from '@scale/scaleui';
import React from 'react';
import BuilderHint from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderHint';
import { ChatDocumentationLink } from '@scale/shared/chat/documentation';

interface ExclusiveWorkerBuilderProps {
  name: string;
  existingValue?: number;
  updateProperty: (arg?: number) => void;
  required?: boolean;
}

const ExclusiveWorkerBuilder: React.FC<ExclusiveWorkerBuilderProps> = ({
  name,
  existingValue,
  updateProperty,
}) => {
  const exclusiveWorkerEnabled = !_.isUndefined(existingValue) && existingValue > 0;
  return (
    <div className="flex flex-col items-start">
      <div className="flex gap-2">
        <Checkbox
          id={name}
          label="Enable Exclusive Worker Routing"
          checked={exclusiveWorkerEnabled}
          onChange={() => {
            updateProperty(exclusiveWorkerEnabled ? undefined : 1);
          }}
        />
        <BuilderHint
          name={name}
          hint={
            'This config is required if you want to guarantee that only the assigned worker can work on the task, and nobody else will be able to claim it. The task will be exclusive to the original worker until N number of days have passed since the task was last worked on. When N days pass, the task will follow the expiration behavior selected below (defaults to moving to L11). '
          }
        />
      </div>
      {exclusiveWorkerEnabled && (
        <>
          <label className="my-1 text-sm font-medium leading-6 text-neutral-700">{name}</label>
          <div className="flex gap-4 mb-1">
            <TextField
              type="number"
              value={existingValue}
              onChange={e => updateProperty(parseInt(e.target.value))}
            />
          </div>
          <div className="mb-2">
            See exclusive worker documentation{' '}
            <a
              className="text-primary-500"
              target="_blank"
              rel="noopener noreferrer"
              href={ChatDocumentationLink.ExclusiveWorker}
            >
              here.
            </a>
          </div>
        </>
      )}
    </div>
  );
};
export default ExclusiveWorkerBuilder;
